<template>
  <div>
    <card-teams />
  </div>
</template>
<script>
/* 
  Class: Teams
  Description: This class representing a main entry point for teams.
*/

/* Imports */
import CardTeams from "@/components/Cards/Teams/CardTeams.vue";
/* /Imports/ */

export default {
  /* 
    Define different meta options. 
  */
  metaInfo() {
    return {
      title: this.$appName,
      titleTemplate: "%s | " + this.$route.name,
    };
  },

  /* 
    Define different components for reusability. 
  */
  components: {
    CardTeams,
  }
};
</script>
